// PULMOX PRO — scripts propios (vanilla, sin librerías externas)

document.documentElement.classList.add('mt-js');

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initMarquee();
  initGaleria();
  initVariantes();
  initAddToCart();
  initStock();
  initUrgencia();
  initStickyCompra();
  initBotonesPremium();
  initTilt();
  initProductoTilt();
  initFaq();
  initScrollProgress();
  initEntrega();
  initPopupEmail();
  initImagenesFade();
  initSliderComparativo();
});

var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- Cambio de texto con cruce suave (opacidad; con blur breve solo donde se pide) ---------- */
function cruzarTexto(el, texto, opciones) {
  if (!el) return;
  opciones = opciones || {};
  el.classList.add('mt-texto-cruce');
  if (opciones.sinBlur) el.classList.add('mt-texto-cruce--sin-blur');
  if (el.textContent === texto) return;
  el.classList.add('is-sale');
  setTimeout(function () {
    el.textContent = texto;
    el.classList.remove('is-sale');
    if (opciones.despues) opciones.despues();
  }, 110);
}
// Los botones llevan su texto dentro de un <span>, para animar solo el texto y no todo el botón.
function spanTextoBoton(btn) {
  var sp = btn.querySelector('.mt-btn__txt');
  if (!sp) {
    sp = document.createElement('span');
    sp.className = 'mt-btn__txt mt-texto-cruce';
    sp.textContent = btn.textContent.trim();
    btn.textContent = '';
    btn.appendChild(sp);
  }
  return sp;
}
function fijarTextoBoton(btn, texto) { spanTextoBoton(btn).textContent = texto; }

/* ---------- Reveals al hacer scroll ---------- */
function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(function (el) { observer.observe(el); });
}

/* ---------- Cifras animadas ---------- */
function initCountUp() {
  var items = document.querySelectorAll('.mt-countup');
  if (!items.length) return;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.textContent = el.dataset.target + (el.dataset.suffix || ''); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      animateCount(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.6 });
  items.forEach(function (el) { observer.observe(el); });
}
function animateCount(el) {
  var target = parseFloat(el.dataset.target || '0');
  var suffix = el.dataset.suffix || '';
  var decimals = el.dataset.target && el.dataset.target.indexOf('.') > -1 ? 1 : 0;
  var duration = 1800;
  var start = null;
  function step(ts) {
    if (!start) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = progress >= 1 ? 1 : 1 - Math.pow(2, -10 * progress);
    var value = target * eased;
    el.textContent = value.toFixed(decimals) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

/* ---------- Barra de stock (se vacía una vez al entrar en pantalla) ---------- */
function initStock() {
  var barras = document.querySelectorAll('[data-mt-stock]');
  if (!barras.length) return;
  function activar(barra) {
    var relleno = barra.querySelector('[data-mt-stock-relleno]') || barra.querySelector('.mt-stock__relleno');
    var nivel = barra.dataset.nivel || '100';
    if (!relleno) return;
    relleno.style.transform = 'scaleX(1)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        relleno.style.transform = 'scaleX(' + (parseFloat(nivel) / 100) + ')';
      });
    });
  }
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    barras.forEach(activar);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        activar(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  barras.forEach(function (b) { observer.observe(b); });
}

/* ---------- Botones: magnético + pulsación + onda al clic ---------- */
function initBotonesPremium() {
  var botones = document.querySelectorAll('.mt-btn');
  if (!botones.length) return;
  botones.forEach(function (btn) {
    if (!prefersReducedMotion && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var pulsado = false;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var relX = e.clientX - r.left - r.width / 2;
        var relY = e.clientY - r.top - r.height / 2;
        var max = 10;
        var tx = Math.max(-max, Math.min(max, relX * 0.25));
        var ty = Math.max(-max, Math.min(max, relY * 0.25));
        btn.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + (pulsado ? 0.96 : 1.05) + ')';
      });
      btn.addEventListener('mouseleave', function () { pulsado = false; btn.style.transform = ''; });
      btn.addEventListener('mousedown', function () { pulsado = true; btn.style.transform = 'scale(0.96)'; });
      btn.addEventListener('mouseup', function () { pulsado = false; });
    }

    btn.addEventListener('click', function (e) {
      var r = btn.getBoundingClientRect();
      var span = document.createElement('span');
      span.className = 'mt-ripple';
      var size = Math.max(r.width, r.height) * 1.8;
      span.style.width = span.style.height = size + 'px';
      span.style.left = (e.clientX - r.left - size / 2) + 'px';
      span.style.top = (e.clientY - r.top - size / 2) + 'px';
      btn.appendChild(span);
      span.addEventListener('animationend', function () { span.remove(); });
    });
  });
}

/* ---------- Tarjetas: inclinación 3D siguiendo el cursor ---------- */
function initTilt() {
  var tarjetas = document.querySelectorAll('.mt-tilt');
  if (!tarjetas.length || prefersReducedMotion || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  tarjetas.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var rotateY = (px - 0.5) * 12;
      var rotateX = (0.5 - py) * 12;
      card.style.transform = 'perspective(900px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) translateY(-8px) scale(1.02)';
    });
    card.addEventListener('mouseenter', function () { card.style.willChange = 'transform'; });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; card.style.willChange = ''; });
  });
}

/* ---------- Producto: rotación 3D + brillo siguiendo el cursor ---------- */
function initProductoTilt() {
  var cajas = document.querySelectorAll('[data-mt-producto-tilt]');
  if (!cajas.length || prefersReducedMotion || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  cajas.forEach(function (caja) {
    var img = caja.querySelector('img');
    var brillo = caja.querySelector('[data-mt-glare]');
    if (!img) return;
    caja.addEventListener('mousemove', function (e) {
      var r = caja.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var rotateY = (px - 0.5) * 16;
      var rotateX = (0.5 - py) * 16;
      img.style.transform = 'perspective(1000px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(1.03)';
      if (brillo) {
        brillo.style.opacity = '1';
        brillo.style.background = 'radial-gradient(circle at ' + (px * 100).toFixed(0) + '% ' + (py * 100).toFixed(0) + '%, rgba(255,255,255,0.25), transparent 42%)';
      }
    });
    caja.addEventListener('mouseenter', function () { img.style.willChange = 'transform'; });
    caja.addEventListener('mouseleave', function () {
      img.style.transform = '';
      img.style.willChange = '';
      if (brillo) brillo.style.opacity = '0';
    });
  });
}

/* ---------- FAQ: acordeón con apertura elástica ---------- */
function initFaq() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var toggle = item.querySelector('[data-mt-faq-toggle]');
    var panel = item.querySelector('[data-mt-faq-panel]');
    if (!toggle || !panel) return;
    panel.style.maxHeight = '0px';
    toggle.addEventListener('click', function () {
      var abierto = item.classList.contains('is-abierto');
      if (abierto) {
        panel.style.maxHeight = '0px';
        item.classList.remove('is-abierto');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        item.classList.add('is-abierto');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ---------- Barra de progreso de scroll ---------- */
function initScrollProgress() {
  var barra = document.getElementById('mt-scroll-progress');
  if (!barra) return;
  function actualizar() {
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    var pct = alto > 0 ? (window.scrollY / alto) * 100 : 0;
    barra.style.transform = 'scaleX(' + (Math.min(100, Math.max(0, pct)) / 100).toFixed(4) + ')';
  }
  window.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar);
  actualizar();
}

/* ---------- Cuenta atrás de oferta (solo con fecha real puesta en la sección) ---------- */
function initUrgencia() {
  var els = document.querySelectorAll('[data-mt-urgencia]');
  if (!els.length) return;
  els.forEach(function (el) {
    var fin = new Date(el.dataset.fin);
    if (isNaN(fin.getTime())) { el.style.display = 'none'; return; }
    var horasEl = el.querySelector('[data-horas]');
    var minutosEl = el.querySelector('[data-minutos]');
    var segundosEl = el.querySelector('[data-segundos]');
    var intervalo;
    function tick() {
      var diff = fin - new Date();
      if (diff <= 0) {
        el.style.display = 'none';
        clearInterval(intervalo);
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      horasEl.textContent = String(h).padStart(2, '0');
      minutosEl.textContent = String(m).padStart(2, '0');
      segundosEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    intervalo = setInterval(tick, 1000);
  });
}

/* ---------- Barra de compra fija (aparece cuando el botón real sale de pantalla) ---------- */
function initStickyCompra() {
  var barra = document.querySelector('[data-mt-sticky]');
  var botonBarra = document.querySelector('[data-mt-sticky-boton]');
  var precioBarra = document.querySelector('[data-mt-sticky-precio]');
  if (!barra || !botonBarra) return;

  var botonReal = document.querySelector('[data-mt-add-btn]');
  var precioReal = document.querySelector('[data-mt-precio]');
  if (!botonReal) return;

  function sincronizarPrecio() {
    if (precioReal && precioBarra) precioBarra.textContent = precioReal.textContent.trim();
  }
  sincronizarPrecio();
  if (precioReal && window.MutationObserver) {
    new MutationObserver(sincronizarPrecio).observe(precioReal, { childList: true, characterData: true, subtree: true });
  }

  botonBarra.addEventListener('click', function () {
    if (!botonReal.disabled) botonReal.click();
  });

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', pasado);
        barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(botonReal);
  }
}

/* ---------- Marquesina infinita de reseñas ---------- */
function initMarquee() {
  var tracks = document.querySelectorAll('.mt-marquee__track');
  tracks.forEach(function (track) {
    if (track.dataset.duplicated) return;
    var children = Array.prototype.slice.call(track.children);
    children.forEach(function (child) {
      track.appendChild(child.cloneNode(true));
    });
    track.dataset.duplicated = 'true';
  });
}

/* ---------- Galería de producto ---------- */
function initGaleria() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    if (!principal) return;
    var img = principal.querySelector('img');
    var cajaVideo = principal.querySelector('[data-mt-galeria-video]');
    var video = cajaVideo ? cajaVideo.querySelector('video') : null;

    if (video) {
      // Siempre silenciado e integrado en la página (iPhone no reproduce en línea sin playsinline)
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      if (prefersReducedMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        video.controls = true;
      }
    }

    function mostrarVideo() {
      if (!video) return;
      cajaVideo.hidden = false;
      if (img) img.hidden = true;
      if (!prefersReducedMotion) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function mostrarFoto(src, alt) {
      if (video) { video.pause(); cajaVideo.hidden = true; }
      if (!img) return;
      img.hidden = false;
      if (!src || img.getAttribute('src') === src) return;
      if (prefersReducedMotion) { img.src = src; img.alt = alt || ''; return; }
      // Crossfade ~200ms: sale con fundido + blur de 2px, se precarga la nueva y entra limpia.
      img.classList.add('mt-cambiando');
      var nueva = new Image();
      var cambiado = false;
      function aplicar() {
        if (cambiado) return;
        cambiado = true;
        img.src = src; img.alt = alt || '';
        requestAnimationFrame(function () { img.classList.remove('mt-cambiando'); });
      }
      nueva.onload = nueva.onerror = function () { setTimeout(aplicar, 90); };
      setTimeout(aplicar, 600);
      nueva.src = src;
    }

    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        if (mini.hasAttribute('data-video')) mostrarVideo();
        else mostrarFoto(mini.getAttribute('data-full'), mini.getAttribute('data-alt'));
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

/* ---------- Selector de variantes ---------- */
function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var contenedor = form.closest('[data-mt-compra]') || form;
    var opciones = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = contenedor.querySelector('[data-mt-precio]');
    var comparadoEl = contenedor.querySelector('[data-mt-precio-comparado]');
    var ahorroEl = contenedor.querySelector('[data-mt-ahorro]');
    var envioEl = contenedor.querySelector('[data-mt-envio]');
    var envioTextoEl = envioEl ? envioEl.querySelector('span') : null;
    var btn = form.querySelector('[data-mt-add-btn]');
    var estadoEl = form.querySelector('[data-mt-estado]');

    function seleccionActual() {
      var seleccion = [];
      opciones.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-seleccionada');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) cruzarTexto(precioEl, variante.price_formatted, { sinBlur: true });
      if (envioEl) {
        if (variante.envio) {
          if (envioTextoEl) envioTextoEl.textContent = variante.envio;
          envioEl.style.display = '';
          envioEl.classList.toggle('mt-compra__envio--gratis', !!variante.envio_gratis);
        } else {
          envioEl.style.display = 'none';
        }
      }
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        if (comparadoEl) { comparadoEl.textContent = variante.compare_at_price_formatted; comparadoEl.style.display = ''; }
        if (ahorroEl) {
          var pct = Math.round((1 - variante.price / variante.compare_at_price) * 100);
          ahorroEl.textContent = '-' + pct + '%';
          ahorroEl.style.display = '';
        }
      } else {
        if (comparadoEl) comparadoEl.style.display = 'none';
        if (ahorroEl) ahorroEl.style.display = 'none';
      }
      if (btn) {
        btn.disabled = !variante.available;
        fijarTextoBoton(btn, variante.available ? btn.dataset.textoDisponible : btn.dataset.textoAgotado);
      }
      if (estadoEl) estadoEl.textContent = variante.available ? '' : estadoEl.dataset.textoAgotado || '';
    }

    opciones.forEach(function (grupo) {
      var valores = grupo.querySelectorAll('[data-valor]');
      valores.forEach(function (valor) {
        valor.addEventListener('click', function () {
          if (valor.disabled) return;
          valores.forEach(function (v) { v.classList.remove('is-seleccionada'); });
          valor.classList.add('is-seleccionada');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

/* ---------- Icono del carrito: bounce + "+1" flotante ---------- */
function animarCarritoAgregado(btn) {
  var iconoCarrito = document.getElementById('cart-icon-bubble');
  if (iconoCarrito) {
    iconoCarrito.classList.remove('mt-cart-bounce');
    void iconoCarrito.offsetWidth;
    iconoCarrito.classList.add('mt-cart-bounce');
    if (!prefersReducedMotion) {
      iconoCarrito.addEventListener('animationend', function limpiar() {
        iconoCarrito.classList.remove('mt-cart-bounce');
        iconoCarrito.removeEventListener('animationend', limpiar);
      });
    } else {
      iconoCarrito.classList.remove('mt-cart-bounce');
    }
  }
  if (!btn || prefersReducedMotion) return;
  var r = btn.getBoundingClientRect();
  var mas1 = document.createElement('span');
  mas1.className = 'mt-flotante-mas1';
  mas1.textContent = '+1';
  mas1.style.left = (r.left + r.width / 2) + 'px';
  mas1.style.top = r.top + 'px';
  document.body.appendChild(mas1);
  setTimeout(function () { mas1.remove(); }, 1000);
}

/* ---------- Añadir al carrito (integra con cart-drawer/cart-notification de Dawn) ---------- */
function initAddToCart() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-mt-add-btn]');
      var estadoEl = form.querySelector('[data-mt-estado]');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var anadido = false;
      if (btn) { btn.disabled = true; fijarTextoBoton(btn, btn.dataset.textoCargando || '...'); }

      var formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            if (estadoEl) estadoEl.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
          }
          animarCarritoAgregado(btn);
          anadido = true;
        })
        .catch(function () {
          if (estadoEl) estadoEl.textContent = 'Ha ocurrido un error. Inténtalo de nuevo.';
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            var normal = btn.dataset.textoDisponible || 'Añadir al carrito';
            if (anadido) {
              // "Añadido ✓" un instante, con cruce suave, y vuelve al texto normal.
              fijarTextoBoton(btn, normal);
              cruzarTexto(spanTextoBoton(btn), 'Añadido ✓');
              setTimeout(function () { cruzarTexto(spanTextoBoton(btn), btn.dataset.textoDisponible || normal); }, 1500);
            } else {
              fijarTextoBoton(btn, normal);
            }
          }
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    });
  });
}


/* ---------- Entrega estimada: textos del widget en español ---------- */
function initEntrega() {
  var cont = document.querySelector('[data-mt-entrega]');
  if (!cont) return;
  var palabras = {
    'order': 'Pídelo', 'today': 'hoy', 'tomorrow': 'mañana', 'within': 'en', 'you\u2019ll': 'y', "you'll": 'y',
    'receive': 'recíbelo', 'between': 'entre', 'to': 'y', 'your': null, 'package': null, ',': null,
    'purchased': 'Pedido', 'processing': 'Preparando', 'delivered': 'Entregado', 'shipped': 'Enviado'
  };
  var meses = { jan: 'ene', apr: 'abr', aug: 'ago', dec: 'dic', sept: 'sep' };
  var aplicando = false;

  function traducir() {
    aplicando = true;
    cont.querySelectorAll('text-display, .essential-estimated-delivery-title').forEach(function (el) {
      var nodo = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim() !== ''; });
      if (!nodo) return;
      var clave = nodo.nodeValue.replace(/\u00a0/g, ' ').trim().toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(palabras, clave)) return;
      if (palabras[clave] === null) { el.setAttribute('data-mt-oculto', ''); return; }
      var nuevo = palabras[clave];
      if (nodo.nodeValue.trim() !== nuevo) nodo.nodeValue = nodo.nodeValue.replace(nodo.nodeValue.trim(), nuevo);
    });
    cont.querySelectorAll('.essential-estimated-delivery-sub-title').forEach(function (el) {
      var t = el.textContent;
      var nuevo = t.replace(/\b(jan|apr|aug|dec|sept)\b/i, function (m) { return meses[m.toLowerCase()]; });
      if (nuevo !== t && el.firstChild && el.firstChild.nodeType === 3) el.firstChild.nodeValue = nuevo;
    });
    aplicando = false;
  }

  traducir();
  if (!('MutationObserver' in window)) return;
  new MutationObserver(function () { if (!aplicando) traducir(); })
    .observe(cont, { childList: true, subtree: true, characterData: true });
}

/* ---------- Popup de bienvenida: código de descuento + newsletter ---------- */
function initPopupEmail() {
  var popup = document.querySelector('[data-mt-popup]');
  if (!popup) return;
  // Nunca en el carrito ni en el checkout.
  if (/^\/(cart|checkouts?)(\/|$)/.test(window.location.pathname)) return;
  var CLAVE = 'mt_popup_bienvenida_visto';

  function yaVisto() {
    try { if (window.localStorage.getItem(CLAVE) === '1') return true; } catch (e) {}
    try { return window.sessionStorage.getItem(CLAVE) === '1'; } catch (e) {}
    return false;
  }
  // Se guarda EN EL MOMENTO en que se muestra, no al cerrar: así no vuelve a salir al navegar.
  function marcarVisto() {
    try { window.localStorage.setItem(CLAVE, '1'); }
    catch (e) { try { window.sessionStorage.setItem(CLAVE, '1'); } catch (e2) {} }
  }

  var temporizadorAnimacion = null;
  // will-change solo mientras dura la animación.
  function animando(ms) {
    popup.classList.add('is-animando');
    clearTimeout(temporizadorAnimacion);
    temporizadorAnimacion = setTimeout(function () { popup.classList.remove('is-animando'); }, ms);
  }

  var abierto = false;
  function abrir() {
    if (abierto) return;
    abierto = true;
    marcarVisto();
    animando(900);
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  function cerrar() {
    if (!abierto || popup.classList.contains('is-cerrando')) return;
    animando(300);
    popup.classList.add('is-cerrando');
    popup.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      popup.classList.remove('is-visible', 'is-cerrando');
      abierto = false;
    }, 190);
  }

  popup.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  var aviso = popup.querySelector('.mt-popup__form-aviso');
  if (aviso) {
    abrir();
  } else if (!yaVisto()) {
    var delay = parseInt(popup.dataset.delay, 10);
    if (isNaN(delay)) delay = 2000;
    setTimeout(abrir, delay);
  }

  var botonCopiar = popup.querySelector('[data-mt-popup-copiar]');
  var codigoEl = popup.querySelector('[data-mt-popup-codigo]');
  if (botonCopiar && codigoEl) {
    var textoBoton = spanTextoBoton(botonCopiar);
    var textoCopiar = botonCopiar.dataset.textoCopiar || 'Copiar código';
    var textoCopiado = botonCopiar.dataset.textoCopiado || '¡Copiado!';
    var volver = null;
    botonCopiar.addEventListener('click', function () {
      var texto = codigoEl.textContent.trim();
      function marcarCopiado() {
        botonCopiar.classList.add('is-copiado');
        cruzarTexto(textoBoton, textoCopiado);
        clearTimeout(volver);
        volver = setTimeout(function () {
          botonCopiar.classList.remove('is-copiado');
          cruzarTexto(textoBoton, textoCopiar);
        }, 1800);
      }
      function copiarConSeleccion() {
        var temp = document.createElement('textarea');
        temp.value = texto;
        temp.setAttribute('readonly', '');
        temp.style.position = 'fixed';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(temp);
        if (ok) marcarCopiado();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(marcarCopiado).catch(copiarConSeleccion);
      } else {
        copiarConSeleccion();
      }
    });
  }
}

/* ---------- Imágenes: aparecen con fade al cargar (solo las lazy que aún no cargaron) ---------- */
function initImagenesFade() {
  var imgs = document.querySelectorAll('main img[loading="lazy"]');
  imgs.forEach(function (img) {
    if (img.complete) return;
    img.classList.add('mt-img-fade', 'mt-img-pendiente');
    function listo() { img.classList.remove('mt-img-pendiente'); }
    img.addEventListener('load', listo, { once: true });
    img.addEventListener('error', listo, { once: true });
  });
  // Red de seguridad: nada se queda invisible.
  setTimeout(function () {
    document.querySelectorAll('img.mt-img-pendiente').forEach(function (i) { i.classList.remove('mt-img-pendiente'); });
  }, 6000);
}

/* ---------- Slider "Sin / Con PULMOX PRO": arrastrable con mouse, touch y teclado ---------- */
function initSliderComparativo() {
  var sliders = document.querySelectorAll('[data-mt-slider-comparativo]');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var capa = slider.querySelector('[data-mt-slider-capa]');
    var manija = slider.querySelector('[data-mt-slider-manija]');
    if (!capa || !manija) return;
    var arrastrando = false;
    var yaInteractuo = false;

    function fijarPorcentaje(pct) {
      pct = Math.max(0, Math.min(100, pct));
      capa.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      manija.style.left = pct + '%';
      manija.setAttribute('aria-valuenow', Math.round(pct));
    }

    function porcentajeDesdeEvento(clientX) {
      var r = slider.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    }

    function quitarInvitacion() {
      if (yaInteractuo) return;
      yaInteractuo = true;
      manija.classList.remove('mt-slidercomp__manija--invitacion');
    }

    manija.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      quitarInvitacion();
      manija.setPointerCapture(e.pointerId);
      manija.classList.add('is-arrastrando');
    });
    manija.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarPorcentaje(porcentajeDesdeEvento(e.clientX));
    });
    function soltar(e) {
      if (!arrastrando) return;
      arrastrando = false;
      manija.classList.remove('is-arrastrando');
    }
    manija.addEventListener('pointerup', soltar);
    manija.addEventListener('pointercancel', soltar);

    manija.addEventListener('keydown', function (e) {
      var actual = parseFloat(manija.style.left) || 50;
      quitarInvitacion();
      if (e.key === 'ArrowLeft') { fijarPorcentaje(actual - 5); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { fijarPorcentaje(actual + 5); e.preventDefault(); }
      else if (e.key === 'Home') { fijarPorcentaje(0); e.preventDefault(); }
      else if (e.key === 'End') { fijarPorcentaje(100); e.preventDefault(); }
    });

    slider.addEventListener('click', function (e) {
      if (e.target === manija || manija.contains(e.target)) return;
      quitarInvitacion();
      // Clic en cualquier punto de la foto (no arrastre): salto suave, con
      // transición — a diferencia del arrastre, que va 1 a 1 con el dedo/mouse.
      slider.classList.add('mt-slidercomp--saltando');
      fijarPorcentaje(porcentajeDesdeEvento(e.clientX));
      setTimeout(function () { slider.classList.remove('mt-slidercomp--saltando'); }, 260);
    });

    // Invitación sutil a arrastrar: un par de "empujones" del manija apenas
    // la sección entra en pantalla, para que se note que es interactivo.
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !yaInteractuo) {
            manija.classList.add('mt-slidercomp__manija--invitacion');
            setTimeout(quitarInvitacion, 2600);
          }
          if (!entry.isIntersecting) obs.unobserve(entry.target);
        });
      }, { threshold: 0.5 });
      obs.observe(slider);
    }
  });
}
